import {inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';

import {RetournerCheminsApplication, VAL_MODE_ROUTEUR} from './val-mode-routeur';

//Service de navigation entre les pages de l’application, selon son mode (cf. provideModeRouteur) :
//en mode routeur, chaque page s’affiche dans la barre d’adresse ; sinon, seule l’accueil y apparaît
@Injectable (
{
  providedIn: 'root'
})
export class ValNavigationService
{
  private router = inject (Router);
  private modeRouteur = inject (VAL_MODE_ROUTEUR);
  private cheminAccueil = RetournerCheminsApplication ().accueil;

  //Affiche une page
  //  Paramètres
  //    cible        : Commande de navigation, ou URL
  //    remplacerUrl : Indique si l’URL de la page remplace l’entrée d’historique en cours, quand elle est affichée
  //  Retourne
  //    Indique si la navigation a abouti
  public Naviguer (cible: any[] | string, remplacerUrl: boolean = false) : Promise<boolean>
  {
    let urlTree: UrlTree;
    let afficherUrl: boolean;

    urlTree = typeof cible === "string" ? this.router.parseUrl (cible) : this.router.createUrlTree (cible);
    afficherUrl = this.modeRouteur || this.router.serializeUrl (urlTree) === this.cheminAccueil;

    return this.router.navigateByUrl (urlTree, {skipLocationChange: !afficherUrl, replaceUrl: afficherUrl && remplacerUrl});
  }
}
